import { Flex, Tooltip, UnstyledButton } from "@mantine/core";
import { IconCopy } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import style from "./contact-us.module.css";
import { useEffect, useState } from "react";

const CopyEmailButton = ({ email }) => {
    const { t } = useTranslation("landing-page");
    const [buttonText, setButtonText] = useState(t("email_copy.click_to_copy"));
    const [isTimerActive, setIsTimerActive] = useState(false);

    useEffect(() => {
        let timer;
        if (isTimerActive) {
            timer = setTimeout(() => {
                setButtonText(t("email_copy.click_to_copy"));
                setIsTimerActive(false);
            }, 2000);
        }

        return () => {
            clearTimeout(timer);
        };
    }, [isTimerActive, t]);

    const handleCopy = () => {
        navigator.clipboard
            .writeText(email)
            .then(() => {
                setButtonText(t("email_copy.email_copied"));
                setIsTimerActive(true);
            })
            .catch((error) => {
                
            });
    };

    return (
        <Tooltip label={buttonText} position="right" withArrow>
            <UnstyledButton onClick={() => handleCopy()} w={"fit-content"}>
                <Flex align={"center"} columnGap={"0.5rem"} w={"fit-content"}>
                    <p className={style.email}>{email}</p>

                    <IconCopy size={"1.25rem"} />
                </Flex>
            </UnstyledButton>
        </Tooltip>
    );
};

export default CopyEmailButton;